'use client';

import React from 'react';

import { affiliateInScope } from '../helpers/affiliateInScope';
import useAffiliateCode from '../hooks/useAffiliateCode';

import Tag from '../../../components/_ui/_blocks/Tag/Tag';
import Typography from '../../../components/_ui/_blocks/Typography/Typography';
import Icon from '../../../components/_ui/_blocks/Icon/Icon';

import styles from './AffiliateDiscountBanner.module.css';

interface Props {
    treatmentId?: number;
    className?: string;
}

/**
 * Affiliate discount banner.
 * @see https://www.figma.com/design/HB2vMGpmieuLtPlJUEfFXi/Hippo-UI-kit-3.1?node-id=2449-10018&node-type=instance&m=dev
 */
const AffiliateDiscountBanner = ({ treatmentId, className }: Props): JSX.Element | null => {
    const affiliateObj = useAffiliateCode();

    if (!affiliateObj || !affiliateObj.discount_code || !affiliateObj.discount_label) {
        return null;
    }

    if (treatmentId && affiliateInScope(treatmentId) === false) {
        return null;
    }

    return (
        <div className={`${styles.banner} ${className || ''}`}>
            <Icon size="medium" icon="tag-light" alt="Sale tag" />
            <Typography as="p" size="090">
                We'll apply code{' '}
                <Tag color="discountCode" size="medium">
                    {affiliateObj.discount_code}
                </Tag>{' '}
                automatically for {affiliateObj.discount_label} when you checkout your first order!
            </Typography>
        </div>
    );
};

export default AffiliateDiscountBanner;
